import "@/App.css";
import "@/lib/print.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import CalculatorPage from "@/pages/Calculator";
import HistoryPage from "@/pages/History";
import LoginPage from "@/pages/Login";
import AdminMasterPage from "@/pages/AdminMaster";
import HospitalConfigPage from "@/pages/HospitalConfig";
import UserManagementPage from "@/pages/UserManagement";
import PrintEstimatePage from "@/pages/PrintEstimate";
import SharePage from "@/pages/SharePage";
import AIModePage from "@/pages/AIMode";
import KnowledgeAIPage from "@/pages/KnowledgeAI";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/share/:token" element={<SharePage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<CalculatorPage />} />
                    <Route path="/riwayat" element={<HistoryPage />} />
                    <Route path="/ai" element={<AIModePage />} />
                    <Route path="/ai/:sessionId" element={<AIModePage />} />
                    <Route path="/knowledge" element={<KnowledgeAIPage />} />
                    <Route path="/print/:id" element={<PrintEstimatePage />} />
                    <Route
                      path="/admin/master"
                      element={
                        <ProtectedRoute requireAdmin>
                          <AdminMasterPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/users"
                      element={
                        <ProtectedRoute requireAdmin>
                          <UserManagementPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/admin/hospital"
                      element={
                        <ProtectedRoute requireAdmin>
                          <HospitalConfigPage />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
